import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import cap17drive from "../index";
import SquadflixLiveView from "../squadflixLive/squadflixLiveView/squadflixLiveView";

function TmdbListIndex({type, onWidthChange, acestreamLinks}) {
    const dispatch = useDispatch();
    const [acestreamSearch, setAcestreamSearch] = useState("");

    const handleSearchAcestream = (value) => {
        setAcestreamSearch(value);
        onWidthChange?.();
    }

    useEffect(() => {
        dispatch(cap17drive.actions.clearSelectedSeason());
        dispatch(cap17drive.actions.clearSelectedSerie());
    }, []);

    if (type === "live") {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>SquadDisk Live</title>
                </Helmet>
                <div style={{marginTop: "10px"}}>
                    <SquadflixLiveView links={acestreamLinks} onWidthChange={onWidthChange} search={acestreamSearch}/>
                </div>
            </div>
        )
    }

    return null;
}

export default TmdbListIndex;
